import React, { FC, useEffect, useState, useContext } from 'react'
import query from 'query-string'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { useApolloClient } from '@apollo/client'
import ROUTES from '../../utils/routes'
import { LocationProps } from '../../IssueView'
import { userStore } from '../../utils/UserContext'
import { Button } from '../../System'
import { StyledAdminIssueHeader } from '.'
import { getIssueBySlugQuery } from '../../../graphql/Issue/getIssueBySlug'
import { GetIssueBySlug } from '../../../graphql/Issue/__generated__/GetIssueBySlug'
import { GetIssueById_issueFindById } from '../../../graphql/Issue/__generated__/GetIssueById'

const AdminIssueHeader: FC = () => {
  const history = useHistory()

  const apollo = useApolloClient()
  const { user } = useContext(userStore)
  const location: LocationProps & { state: { issue: GetIssueById_issueFindById } } = useLocation()
  const [issueId, setIssueId] = useState<string | undefined>()
  const { id: urlId } = query.parse(location.search)
  const { slug }: any = useParams()

  const getIssueIdBySlug = async (issueSlug: string) => {
    const passedIssueId = location?.state?.issue?.id || urlId

    if (passedIssueId) {
      return setIssueId(passedIssueId)
    }

    const { data } = await apollo.query<GetIssueBySlug>({
      query: getIssueBySlugQuery,
      variables: { slug: issueSlug }
    })

    return setIssueId(data?.issueFindOne?._id)
  }

  useEffect(() => {
    if (user?.role !== 'admin') {
      return
    }

    getIssueIdBySlug(slug)
  }, [location, slug, user])

  const editURL = ROUTES.admin.issues.editByIdMain(issueId as string)

  if (user?.role !== 'admin') {
    return null
  }

  return (
    <StyledAdminIssueHeader>
      <div className="container">
        <p>Viewing as Admin</p>
        <Button onClick={() => history.push(editURL)}>Edit Action Plan</Button>
      </div>
    </StyledAdminIssueHeader>
  )
}

export default AdminIssueHeader
